/** @jsx jsx */
import { jsx } from '@emotion/core';
import { fontSize } from '@atlaskit/theme/constants';
import { gs } from '../utils';
export var Name = function (_a) {
    var name = _a.name, _b = _a.isLeftPadded, isLeftPadded = _b === void 0 ? true : _b, testId = _a.testId;
    return (jsx("p", { css: {
            margin: 0,
            fontSize: fontSize() + "px",
            fontWeight: 500,
            marginLeft: isLeftPadded ? gs(1) : '0px',
        }, "data-testid": testId }, name));
};
//# sourceMappingURL=Name.js.map